import React, { FC }                                   from 'react';
import { useAuth0 }                                    from '@auth0/auth0-react';
import { Button, Container, Divider, Header, Segment } from 'semantic-ui-react';
import { Cell, Grid }                                  from 'styled-css-grid';

import { useLogout }                                      from '../../../../hooks';
import { CorvalUtilHexColors, SemanticUIColor, Size }     from '../../../../types';
import { GenericContentLayout, Page, StyledContainer }    from '../../../containers';
import { CorvalStylizedHexContainer }                     from '../../../components/product/CorvalStylizedHexContainer';
import { PageMeta }                                       from '../../../containers/PageMeta';
import { HelpAndSupportStatement }                        from '../../../components/util/messaging/HelpAndSupportStatement';
import { CHARACTER_VISUAL_AID, CorvalCharacterVisualAid } from '../../../components/product/CorvalCharacterVisualAid';

const AccountNotFoundPage: FC = ( props ) => {
	
	let { logout }                = useLogout(),
	    { user, isAuthenticated } = useAuth0();
	
	return (
		<Page name={ 'not-found' }
		      showTop={ true }
		      showNav={ false }
		      padMainHorizontal={ true }
		      padMainVertical={ true }
		      showBrand={ true }
		      showToggleMode={ false }>
			
			<CorvalStylizedHexContainer inverted fill={ 'area' } bgColor={ SemanticUIColor.BLUE } fadeColor={ CorvalUtilHexColors.DARK_BLUE } fadeDirection={ 'down' }/>
			
			<PageMeta title={ 'Corval Account Not Found' }>
				
				<Container>
					<GenericContentLayout
						topAreaComponent={ null }
						withTopSideArea={ false }
						withBottomSideArea={ false }>
						
						<Segment>
							
							<StyledContainer padding={ Size.LG }>
								
								<Grid columns={ `300px auto` } rows={ `auto auto` } columnGap={ '50px' }>
									<Cell>
										
										<CorvalCharacterVisualAid fluid={ true } type={ CHARACTER_VISUAL_AID.CORVAL_HEX_INTERFACING_WITH_USERS }/>
									
									</Cell>
									<Cell>
										
										<Header as={ 'h2' } color={ 'purple' }>About Corval Accounts</Header>
										<p className={ 'text--md text-height--xl' }><strong>Hey there{ ( isAuthenticated && user.given_name ) ? `, ${ user.given_name }` : '' }! You don’t appear to have access to Corval...</strong></p>
										<p className={ 'text--md text-height--xl' }>If you have made arrangements for an account to be setup with Corval, it is possible that it is still being processed or setup. Please give our accounts team at least 24 hours to complete your request.</p>
										<p className={ 'text--md text-height--xl' }><HelpAndSupportStatement contactName={ `Corval's Accounts Team` }/></p>
										
										<Divider/>
									
									</Cell>
									<Cell top={ 2 } left={ 2 } className={ 'text-right' }>
										
										<Button onClick={ () => { logout() } } primary basic>Logout</Button>
									
									</Cell>
								</Grid>
							
							</StyledContainer>
						</Segment>
					
					</GenericContentLayout>
				</Container>
			
			</PageMeta>
		
		</Page>
	);
}

export default AccountNotFoundPage;
